(function() {
    'use strict';

    angular.module('remitEventsApp').config(function($stateProvider) {
        $stateProvider
            .state('productionUnit', {
                parent: 'site',
                url: '/productionUnits',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'remitEventsApp.productionUnit.home.title'
                },
                views: {
                    content: {
                        templateUrl: 'scripts/app/entities/productionUnit/productionUnits.html',
                        controller: 'ProductionUnitController'
                    }
                },
                resolve: {
                    translatePartialLoader: [
                        '$translate',
                        '$translatePartialLoader',
                        function($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('productionUnit');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }
                    ]
                }
            })
            .state('productionUnit-detail', {
                parent: 'site',
                url: '/productionUnit/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'remitEventsApp.productionUnit.detail.title'
                },
                views: {
                    content: {
                        templateUrl: 'scripts/app/entities/productionUnit/productionUnit-detail.html',
                        controller: 'ProductionUnitDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: [
                        '$translate',
                        '$translatePartialLoader',
                        function($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('productionUnit');
                            return $translate.refresh();
                        }
                    ],
                    entity: [
                        '$stateParams',
                        'ProductionUnit',
                        function($stateParams, ProductionUnit) {
                            return ProductionUnit.get({ id: $stateParams.id });
                        }
                    ]
                }
            })
            .state('productionUnit-new', {
                parent: 'productionUnit',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: [
                    '$state',
                    '$uibModal',
                    function($state, $uibModal) {
                        $uibModal
                            .open({
                                templateUrl: 'scripts/app/entities/productionUnit/productionUnit-dialog.html',
                                controller: 'ProductionUnitDialogController',
                                size: 'lg',
                                resolve: {
                                    entity: function() {
                                        return {
                                            name: null,
                                            shortName: null,
                                            powerplant: null,
                                            marketParticipant: null,
                                            marketParticipantCode: null,
                                            eicCode: null,
                                            regionEicCode: null,
                                            minPower: null,
                                            maxPower: null,
                                            disposablePower: null,
                                            id: null
                                        };
                                    }
                                }
                            })
                            .result.then(
                                function() {
                                    $state.go('productionUnit', null, { reload: true });
                                },
                                function() {
                                    $state.go('productionUnit');
                                }
                            );
                    }
                ]
            })
            .state('productionUnit-edit', {
                parent: 'productionUnit',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: [
                    '$stateParams',
                    '$state',
                    '$uibModal',
                    function($stateParams, $state, $uibModal) {
                        $uibModal
                            .open({
                                templateUrl: 'scripts/app/entities/productionUnit/productionUnit-dialog.html',
                                controller: 'ProductionUnitDialogController',
                                size: 'lg',
                                resolve: {
                                    entity: [
                                        'ProductionUnit',
                                        function(ProductionUnit) {
                                            return ProductionUnit.get({ id: $stateParams.id });
                                        }
                                    ]
                                }
                            })
                            .result.then(
                                function() {
                                    $state.go('productionUnit', null, { reload: true });
                                },
                                function() {
                                    $state.go('^');
                                }
                            );
                    }
                ]
            });
    });
})();
